import SellerNetSheetCalculator from "@/components/tools/SellerNetSheetCalculator";
import ValuationHeader from "@/components/public/ValuationHeader";
import Footer from "@/pages/marketing/components/Footer";
import PageSEO from "@/components/seo/PageSEO";
import StructuredData from "@/components/seo/StructuredData";

const SellerNetSheetPage = () => {
  return (
    <div className="min-h-screen bg-godyspo-background">
      <PageSEO
        title="Seller Net Sheet Calculator | Estimate Your Home Sale Proceeds"
        description="Free seller net sheet calculator. Estimate your net proceeds from selling your home by calculating closing costs, commissions, and mortgage payoffs."
        canonical="/seller-net-sheet"
        keywords="seller net sheet, home sale calculator, closing costs calculator, real estate net proceeds, sell house estimate"
      />
      <StructuredData 
        type="BreadcrumbList" 
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "For Homeowners", url: "/consumer" },
          { name: "Seller Net Sheet", url: "/seller-net-sheet" }
        ]} 
      />
      <ValuationHeader />
      <div className="container mx-auto px-4 py-8 max-w-2xl">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-2">
            Seller Net Sheet Calculator
          </h1>
          <p className="text-muted-foreground">
            Estimate how much you'll receive after selling your property
          </p>
        </div>
        
        <SellerNetSheetCalculator />
      </div>
      <Footer />
    </div>
  );
};

export default SellerNetSheetPage;
